import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function normalizeNotificationPath(actionUrl = '') {
  try {
    const target = new URL(actionUrl || '/dashboard', window.location.origin);
    if (target.origin !== window.location.origin) return '/dashboard';
    return `${target.pathname}${target.search}${target.hash}` || '/dashboard';
  } catch (err) {
    return '/dashboard';
  }
}

export default function NotificationClickNavigator() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof navigator === 'undefined' || !navigator.serviceWorker) return undefined;

    const handleServiceWorkerMessage = (event) => {
      if (event.data?.type !== 'NOTIFICATION_NAVIGATE') return;
      navigate(normalizeNotificationPath(event.data.actionUrl));
    };

    navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
    return () => {
      navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
    };
  }, [navigate]);

  return null;
}
